module.exports = "/_next/static/images/03235f07461791e8750c66ac0a246ca3-cards-and-device@1x.jpg.webp";